// Can't use Typography.Text as it renders with incorrect background / font-color
import styled from "styled-components";

// for tooltips.
export const TooltipCode = styled.span`
  font-family: monospace;
  color: rgb(0, 171, 142);
`;
